import { P, Strong } from '@ahmdigital/ui';

import constants from '../../../ahm-constants';

export default {
  description: (
    <P>
      You also get <Strong>dental</Strong> including <Strong>braces</Strong>, plus <Strong>optical</Strong> and{' '}
      <Strong>laser eye surgery</Strong>. You’ll be loving life with plenty of extras goodness.
    </P>
  ),
  getSellingPoints: () => [
    {
      description: 'Frames, prescription lenses and contact lenses included.',
      title: '100% back on optical',
    },
    {
      description: 'on included extras.',
      title: 'No 2 or 6 month waiting periods',
    },
    {
      description: 'Available at select dentists.',
      title: 'No gap dental check-ups',
    },
  ],
  upgrade: {
    cta: 'Lose the family limits with family extras',
    id: constants.PRODUCT.FAMILY_EXTRAS,
    title: '',
  },
};
